// src/pages/TermsOfService.jsx
import React, { useEffect }  from "react";
import { useNavigate } from "react-router-dom";
import "./LegalPages.css";

const TermsOfService = () => {
  const navigate = useNavigate();

  useEffect(() => {
  document.documentElement.style.scrollBehavior = "auto";
  window.scrollTo(0, 0);
}, []);

  return (
    <div className="legal-page">
      <div className="legal-hero">
        <button type="button" className="legal-back-btn" onClick={() => navigate(-1)}>
          ← Back
        </button>

        <div>
          <p className="legal-eyebrow">PayWeek Inc.</p>
          <h1>Terms of Service</h1>
          <p className="legal-date">
            <strong>Effective Date:</strong> 10/5/2023
          </p>
        </div>
      </div>

      <main className="legal-container">
        <section>
          <p>
            These Terms of Service ("Terms") govern your access to and use of
            PayWeek Inc., including our website, mobile application, and related
            payroll, accounting, invoicing, and financial management services.
          </p>

          <p>
            By accessing or using PayWeek Inc., you agree to these Terms. If you do
            not agree, you may not use our services.
          </p>
        </section>

        <section>
          <h2>1. Description of Services</h2>
          <p>
            PayWeek Inc. provides business tools that may include payroll
            management, accounting features, transaction tracking, financial
            reporting, invoice creation, employee record management, and integrations
            with third-party financial services.
          </p>
        </section>

        <section>
          <h2>2. Account Registration and Access</h2>
          <p>
            Some features require an account. You agree to provide accurate,
            complete, and current information. You are responsible for maintaining
            the confidentiality of your login credentials and for all activity under
            your account.
          </p>
        </section>

        <section>
          <h2>3. Business and Payroll Responsibility</h2>
          <p>
            PayWeek Inc. provides tools to help manage payroll and business finances.
            However, you are responsible for reviewing all payroll, tax, accounting,
            employee, invoice, and financial information before relying on it or
            submitting it to any government agency, employee, customer, or third
            party.
          </p>
        </section>

        <section>
          <h2>4. No Legal, Tax, or Financial Advice</h2>
          <p>
            PayWeek Inc. does not provide legal, tax, accounting, payroll compliance,
            or financial advice. Any calculations, summaries, reports, or outputs
            provided by the app are for informational and business management
            purposes only. You should consult a qualified professional for advice
            specific to your business.
          </p>
        </section>

        <section>
          <h2>5. Third-Party Services</h2>
          <p>
            PayWeek Inc. may integrate with third-party services such as Plaid for
            financial account connectivity and Twilio for SMS communications. Your
            use of these third-party services may be subject to their own terms and
            privacy policies. We are not responsible for third-party services,
            outages, errors, or data handling practices.
          </p>
        </section>

        <section>
          <h2>6. SMS Verification and Communications</h2>
          <p>
            By providing your phone number and consenting to SMS messages, you agree
            that PayWeek Inc. may send you account verification, OTP, security, and
            related account messages. Message frequency may vary. Message and data
            rates may apply. You may reply STOP to opt out or HELP for help where
            supported.
          </p>
        </section>

        <section>
          <h2>7. Acceptable Use</h2>
          <p>You agree not to:</p>
          <ul>
            <li>Use PayWeek Inc. for unlawful or fraudulent purposes</li>
            <li>Attempt to access accounts or systems without authorization</li>
            <li>Interfere with or disrupt the operation of the service</li>
            <li>Upload malicious code or harmful content</li>
            <li>Misrepresent your identity, business, payroll, or financial information</li>
            <li>Use the service in violation of applicable laws or regulations</li>
          </ul>
        </section>

        <section>
          <h2>8. Fees and Payments</h2>
          <p>
            Some services may require payment. If paid services are offered, you
            agree to pay all applicable fees. Fees are non-refundable unless
            otherwise stated or required by law.
          </p>
        </section>

        <section>
          <h2>9. Data and Privacy</h2>
          <p>
            Your use of PayWeek Inc. is also governed by our Privacy Policy. By using
            our services, you consent to our collection and use of information as
            described in the Privacy Policy.
          </p>
        </section>

        <section>
          <h2>10. Service Availability</h2>
          <p>
            We aim to keep PayWeek Inc. available and reliable, but we do not
            guarantee that the service will always be uninterrupted, secure, or
            error-free. We may update, modify, suspend, or discontinue parts of the
            service at any time.
          </p>
        </section>

        <section>
          <h2>11. Termination</h2>
          <p>
            We may suspend or terminate your access to PayWeek Inc. if you violate
            these Terms, misuse the service, create risk for other users, or if
            required by law. You may stop using the service at any time.
          </p>
        </section>

        <section>
          <h2>12. Limitation of Liability</h2>
          <p>
            To the fullest extent permitted by law, PayWeek Inc. and its owners,
            employees, contractors, and service providers will not be liable for
            indirect, incidental, special, consequential, or punitive damages,
            including lost profits, lost data, payroll errors, tax penalties,
            business interruption, or financial losses resulting from your use of
            the service.
          </p>
        </section>

        <section>
          <h2>13. Indemnification</h2>
          <p>
            You agree to indemnify and hold harmless PayWeek Inc. from claims,
            damages, losses, liabilities, and expenses arising from your use of the
            service, your violation of these Terms, your violation of law, or your
            business, payroll, tax, accounting, or financial decisions.
          </p>
        </section>

        <section>
          <h2>14. Changes to These Terms</h2>
          <p>
            We may update these Terms from time to time. Updated Terms will be
            posted on this page with a revised effective date. Continued use of
            PayWeek Inc. after changes means you accept the updated Terms.
          </p>
        </section>

        <section>
          <h2>15. Governing Law</h2>
          <p>
            These Terms are governed by the laws of the United States, without
            regard to conflict of law principles.
          </p>
        </section>

        <section className="legal-contact-card">
          <h2>16. Contact Us</h2>
          <p>If you have questions about these Terms, contact us:</p>
          <p>
            <strong>Company:</strong> PayWeek Inc.
            <br />
            <strong>Website:</strong>{" "}
            <a href="https://www.payweek.com" target="_blank" rel="noopener noreferrer">
              www.payweek.com
            </a>
          </p>
        </section>
      </main>
    </div>
  );
};

export default TermsOfService;